export { AllMeetingsViewAdaptive as default } from "../../../navigation/ResponsiveScreens";
